module.exports = __webpack_public_path__ + "img/Fogretful.8a2cc79a.png";